import clsx from "clsx";
import { useState } from "react";
import { Text, View } from "./base";
import { SessionTagPill } from "./SessionTagPill";

type SessionTagListProps = {
  tags: string[];
  maxVisible?: number;
  onTagClick?: (tag: string) => void;
};

export const SessionTagList = ({ tags, maxVisible = 2, onTagClick }: SessionTagListProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!tags || tags.length === 0) {
    return null;
  }

  const visibleTags = tags.slice(0, maxVisible);
  const hiddenTags = tags.slice(maxVisible);
  const hasOverflow = hiddenTags.length > 0;

  return (
    <View className="flex flex-row items-center gap-1 relative">
      {visibleTags.map((tag) => (
        <SessionTagPill
          key={tag}
          tag={tag}
          onClick={onTagClick}
        />
      ))}
      {hasOverflow && (
        <View
          className="relative"
          onMouseEnter={() => setIsExpanded(true)}
          onMouseLeave={() => setIsExpanded(false)}
        >
          <Text
            className={clsx(
              "text-xs px-1.5 py-0.5 rounded cursor-pointer",
              "bg-gray-100 dark:bg-gray-700/50 text-gray-500 dark:text-gray-400",
              "hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors",
            )}
          >
            +{hiddenTags.length}
          </Text>
          {isExpanded && (
            <View
              className={clsx(
                "absolute z-50 top-full left-0 mt-1 p-2",
                "bg-white dark:bg-gray-800 rounded-lg shadow-lg",
                "border border-gray-200 dark:border-gray-700",
                "flex flex-col gap-1.5 min-w-max",
              )}
            >
              <Text className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">All tags</Text>
              {tags.map((tag) => (
                <SessionTagPill
                  key={tag}
                  tag={tag}
                  onClick={onTagClick}
                />
              ))}
            </View>
          )}
        </View>
      )}
    </View>
  );
};
